// import { run } from "https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@v3.0.0-rc.16/dist/cookieconsent.esm.js";

import * as CookieConsent from "vanilla-cookieconsent";

CookieConsent.run({
  page_scripts: true, // default: false
  // forceConsent: true,

  // onAccept: () => {
  //   if (cc.allowedCategory("analytics")) {
  //     enableAnalytics();
  //   }
  // },

  // onChange: (cookie, changedCategories) => {
  //   console.log(cookie["changedCategories"], changedCategories);
  //   if (cookie.changedCategories.includes("analytics")) {
  //     if (allowedCategory("analytics")) {
  //       enableAnalytics();
  //     } else {
  //       // handle disable logic
  //       window.analyticsEnabled = false;
  //     }
  //   }
  // },

  // onFirstConsent: () => {
  //   console.log("onFirstAction fired");
  // },

  // onConsent: () => {
  //   console.log("onConsent fired ...");
  // },

  // onChange: function (cookie, changed_preferences) {
  //   console.log("onChange fired!");

  //   // If analytics category is disabled => disable google analytics
  //   // if (!cc.allowedCategory("analytics")) {
  //   //   typeof gtag === "function" &&
  //   //     gtag("consent", "update", {
  //   //       analytics_storage: "denied",
  //   //     });
  //   // }
  // },
  guiOptions: {
    consentModal: {
      layout: "box wide",
      position: "bottom center",
      equalWeightButtons: true,
      flipButtons: false,
    },
    preferencesModal: {
      layout: "box",
      position: "right",
      equalWeightButtons: true,
      flipButtons: false,
    },
  },
  categories: {
    necessary: {
      readOnly: true,
    },
    analytics: {
      autoClear: {
        cookies: [
          {
            name: /^(_ga|_gid)/,
          },
        ],
      },
    },
    marketing: {},
  },
  language: {
    default: "sl",
    // autoDetect: "browser",
    translations: {
      sl: {
        consentModal: {
          label: "Cookie consent",
          // title: "Hello traveller, it's cookie time!",
          description:
            'Spletni portal N24 uporabljaja piškotke zaradi tehničnih in varnostnih razlogov (nujni piškotki), za namen analiziranja prometa (analitični piškotki) in oglaševanja (oglaševalski piškotki). Več o piškotkih si lahko preberete v <a href="/politika-piskotkov">Politiki piškotkov.</a>',
          acceptAllBtn: "Dovoli vse",
          acceptNecessaryBtn: "Dovoli nujne",
          showPreferencesBtn: "Nastavitve piškotkov",
        },
        preferencesModal: {
          title:
            '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2" viewBox="0 0 16 16"><defs> <clipPath id="cookies"> <path fill="currentColor" stroke="#707070" d="M-32 2.26h16v16h-16z" data-name="Rectangle 2409"/> </clipPath> </defs> <g clip-path="url(#cookies)" data-name="Mask Group 6683" transform="translate(32 -2.26)"> <path d="M-25.19 8.73a1.19 1.19 0 0 0 .88-.36 1.2 1.2 0 0 0 .36-.88 1.19 1.19 0 0 0-.36-.88 1.2 1.2 0 0 0-.88-.36 1.19 1.19 0 0 0-.88.37 1.2 1.2 0 0 0-.35.87 1.19 1.19 0 0 0 .36.88 1.2 1.2 0 0 0 .87.36Zm-1.6 3.99a1.19 1.19 0 0 0 .88-.36 1.2 1.2 0 0 0 .36-.88 1.19 1.19 0 0 0-.36-.87 1.2 1.2 0 0 0-.87-.36 1.19 1.19 0 0 0-.88.36 1.2 1.2 0 0 0-.36.88 1.19 1.19 0 0 0 .36.87 1.2 1.2 0 0 0 .88.36Zm5.19.76a.77.77 0 0 0 .57-.23.77.77 0 0 0 .23-.57.77.77 0 0 0-.23-.57.77.77 0 0 0-.57-.23.77.77 0 0 0-.57.23.77.77 0 0 0-.23.57.77.77 0 0 0 .23.57.77.77 0 0 0 .57.23Zm-2.39 4.78a7.72 7.72 0 0 1-3.1-.63 8.1 8.1 0 0 1-2.54-1.71 8.1 8.1 0 0 1-1.71-2.54 7.72 7.72 0 0 1-.63-3.1 7.72 7.72 0 0 1 .63-3.09 8.3 8.3 0 0 1 1.7-2.55 8.1 8.1 0 0 1 2.52-1.74 7.43 7.43 0 0 1 3.05-.64 1.64 1.64 0 0 1 1.03.3 1.4 1.4 0 0 1 .49.94 3.28 3.28 0 0 0 1 1.96 3.48 3.48 0 0 0 1.98.97 1.07 1.07 0 0 1 .65.32 1.53 1.53 0 0 1 .34.74 2.21 2.21 0 0 0 .52 1.1 3.04 3.04 0 0 0 1 .77 1.9 1.9 0 0 1 .86.72 1.68 1.68 0 0 1 .16 1.06 7.44 7.44 0 0 1-.83 2.77 8.1 8.1 0 0 1-1.74 2.27 8.2 8.2 0 0 1-2.44 1.52 7.72 7.72 0 0 1-2.94.56Zm0-1.2a6.4 6.4 0 0 0 4.7-1.87 7.07 7.07 0 0 0 2.1-4.6 4.1 4.1 0 0 1-1.74-1.18 3.6 3.6 0 0 1-.83-1.8 4.46 4.46 0 0 1-2.72-1.4 4.58 4.58 0 0 1-1.27-2.74 6.4 6.4 0 0 0-2.76.48 6.96 6.96 0 0 0-2.24 1.47 6.82 6.82 0 0 0-1.48 2.2 6.69 6.69 0 0 0-.54 2.65 6.54 6.54 0 0 0 1.97 4.82 6.54 6.54 0 0 0 4.81 1.98Zm.02-6.88Z"/> </g></svg> Nastavitve piškotkov',
          acceptAllBtn: "Dovoli vse",
          acceptNecessaryBtn: "Dovoli nujne",
          savePreferencesBtn: "Dovoli izbrane",
          closeIconLabel: "Close",
          serviceCounterLabel: "Service|Services",
          sections: [
            // {
            //   title: "Cookie Usage",
            //   description:
            //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            // },
            {
              title:
                '<div class="pm__section-title-inner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" class="w-3.5 h-3.5 mr-2"> <defs> <clipPath id="documentCheck"> <path fill="currentColor" stroke="#707070" d="M1176 509h14v14h-14z" data-name="Rectangle 2410"/> </clipPath> </defs> <g clip-path="url(#documentCheck)" data-name="Mask Group 6687" transform="translate(-1176 -509)"> <path d="m1182.2 518.57-1.47-1.47a.5.5 0 0 0-.16-.1.45.45 0 0 0-.17-.04.43.43 0 0 0-.18.04.47.47 0 0 0-.16.12.48.48 0 0 0-.13.34.46.46 0 0 0 .13.34l1.77 1.77a.53.53 0 0 0 .17.12.53.53 0 0 0 .2.04.5.5 0 0 0 .18-.04.53.53 0 0 0 .18-.12l3.31-3.3a.47.47 0 0 0 .14-.35.46.46 0 0 0-.14-.34.47.47 0 0 0-.34-.14.46.46 0 0 0-.34.14Zm-3.75 4.43a1 1 0 0 1-.73-.32 1 1 0 0 1-.32-.73v-11.9a1 1 0 0 1 .32-.74 1 1 0 0 1 .73-.31h5.88a1.01 1.01 0 0 1 .42.09 1.1 1.1 0 0 1 .33.22l3.2 3.2a1.1 1.1 0 0 1 .23.34 1.01 1.01 0 0 1 .09.42v8.68a1 1 0 0 1-.32.73 1 1 0 0 1-.73.32Zm5.8-10.22v-2.73h-5.8v11.9h9.1v-8.65h-2.78a.5.5 0 0 1-.38-.15.5.5 0 0 1-.15-.37Zm-5.8-2.73Z"/> </g></svg> Nujni piškotki <small class="text-salmon"> (obvezno)</small></div>',
              description:
                "Ti piškotki omogočajo normalno delovanje spletnega mesta in njegovih osnovnih funkcionalnosti. Brez namestitve tovrstnih piškotkov vam nemotenega dostopa do spletnega mesta ne moremo omogočiti.",
              linkedCategory: "necessary",
            },
            {
              title:
                '<div class="pm__section-title-inner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" class="w-3.5 h-3.5 mr-2"> <defs> <clipPath id="analyticsChart"> <path fill="currentColor" stroke="#707070" d="M1148 507h14v14h-14z" data-name="Rectangle 2410"/> </clipPath> </defs> <g clip-path="url(#analyticsChart)" data-name="Mask Group 6689" transform="translate(-1148 -507)"> <path d="M1151.77 513.96a.56.56 0 0 0-.42.17.57.57 0 0 0-.16.42v2.82a.56.56 0 0 0 .16.41.57.57 0 0 0 .42.17.56.56 0 0 0 .42-.17.57.57 0 0 0 .16-.41v-2.83a.56.56 0 0 0-.16-.4.57.57 0 0 0-.42-.18Zm6.45-4.18a.56.56 0 0 0-.41.17.57.57 0 0 0-.17.42v7a.56.56 0 0 0 .17.41.57.57 0 0 0 .42.17.56.56 0 0 0 .41-.17.57.57 0 0 0 .17-.41v-7a.56.56 0 0 0-.17-.42.57.57 0 0 0-.42-.17Zm-3.22 5.87a.56.56 0 0 0-.42.17.57.57 0 0 0-.16.41v1.13a.56.56 0 0 0 .16.42.57.57 0 0 0 .42.17.56.56 0 0 0 .42-.17.57.57 0 0 0 .16-.42v-1.13a.56.56 0 0 0-.17-.41.57.57 0 0 0-.41-.17Zm-5.83 5.35a1.12 1.12 0 0 1-.82-.35 1.12 1.12 0 0 1-.35-.82v-11.66a1.12 1.12 0 0 1 .35-.82 1.12 1.12 0 0 1 .82-.35h11.66a1.12 1.12 0 0 1 .82.35 1.12 1.12 0 0 1 .35.82v11.66a1.12 1.12 0 0 1-.35.82 1.12 1.12 0 0 1-.82.35Zm0-1.17h11.66v-11.66h-11.66Zm0-11.66Zm5.83 5.8a.56.56 0 0 0 .42-.18.57.57 0 0 0 .16-.41.56.56 0 0 0-.17-.42.57.57 0 0 0-.41-.17.56.56 0 0 0-.42.17.57.57 0 0 0-.16.42.56.56 0 0 0 .16.42.57.57 0 0 0 .42.16Z"/> </g></svg> Analitični piškotki</div>',
              description:
                "Tovrstni piškotki zbirajo anonimne informacije o uporabi spletne strani. S tem lastnikom spletne strani pomagajo razumeti, kako obiskovalci uporabljajo spletno stran in na podlagi teh informacij lahko načrtujejo izboljšano uporabniško izkušnjo.",
              linkedCategory: "analytics",
              // cookieTable: {
              //   headers: {
              //     name: "Name",
              //     description: "Description",
              //     Service: "Service",
              //   },
              //   body: [
              //     {
              //       name: "_ga_*, _gid",
              //       description: "Used to track you ...",
              //       Service: "Google Analytics",
              //     },
              //   ],
              // },
            },
            {
              title:
                '<div class="pm__section-title-inner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" class="w-3.5 h-3.5 mr-2"> <defs> <clipPath id="click"> <path fill="currentColor" stroke="#707070" d="M1148 507h14v14h-14z" data-name="Rectangle 2410"/> </clipPath> </defs> <g clip-path="url(#click)" data-name="Mask Group 6690" transform="translate(-1148 -507)"> <path d="M1154.67 518a4.01 4.01 0 0 1-2.78-1.26 3.98 3.98 0 0 1-1.14-2.86 3.98 3.98 0 0 1 1.2-2.92 3.98 3.98 0 0 1 2.93-1.2 3.98 3.98 0 0 1 2.85 1.13 4.03 4.03 0 0 1 1.27 2.8l-1.08-.34a3.04 3.04 0 0 0-1.03-1.84 2.97 2.97 0 0 0-2-.73 2.99 2.99 0 0 0-2.2.9 2.99 2.99 0 0 0-.9 2.2 2.98 2.98 0 0 0 .73 2 3.02 3.02 0 0 0 1.83 1.04Zm.21 2.76a6.7 6.7 0 0 1-2.68-.54 6.95 6.95 0 0 1-2.19-1.47 6.95 6.95 0 0 1-1.47-2.19 6.7 6.7 0 0 1-.54-2.68 6.7 6.7 0 0 1 .54-2.68 6.95 6.95 0 0 1 1.47-2.19 6.95 6.95 0 0 1 2.19-1.47 6.7 6.7 0 0 1 2.68-.54 6.7 6.7 0 0 1 2.68.54 6.95 6.95 0 0 1 2.19 1.47 6.95 6.95 0 0 1 1.47 2.19 6.7 6.7 0 0 1 .54 2.68v.31q0 .16-.03.31l-1-.31v-.31a5.64 5.64 0 0 0-1.7-4.14 5.64 5.64 0 0 0-4.15-1.7 5.64 5.64 0 0 0-4.14 1.7 5.64 5.64 0 0 0-1.7 4.14 5.64 5.64 0 0 0 1.7 4.14 5.64 5.64 0 0 0 4.14 1.7h.31l.31 1-.31.03h-.3Zm5.68.15-2.76-2.75-.6 1.83a.24.24 0 0 1-.25.18.24.24 0 0 1-.24-.2l-1.7-5.63a.24.24 0 0 1 .07-.26.24.24 0 0 1 .27-.06l5.62 1.68a.24.24 0 0 1 .2.24.24.24 0 0 1-.18.26l-1.82.6 2.74 2.75a.26.26 0 0 1 .1.2.26.26 0 0 1-.1.18l-.98.98a.26.26 0 0 1-.18.09.26.26 0 0 1-.2-.09Z"/> </g></svg> Oglaševalski piškotki</div>',
              description:
                "Ti piškotki anonimno zbirajo podatke o obiskih spletne strani. Uporabljajo jih oglaševalci, da prikazujejo oglase, za katere ocenijo, da so relevantni za obiskovalca. Uporabljajo se tudi za preprečevanje prikazovanja oglasov, ki so obiskovalcu že bili prikazani.",
              linkedCategory: "marketing",
            },
            {
              // title: "More information",
              description:
                'Spletni portal N24 uporabljaja piškotke zaradi tehničnih in varnostnih razlogov (nujni piškotki), za namen analiziranja prometa (analitični piškotki) in oglaševanja (oglaševalski piškotki). Več o piškotkih si lahko preberete v <a href="/politika-piskotkov">Politiki piškotkov.</a>',
            },
          ],
        },
      },
    },
  },
});

function enableAnalytics() {
  // example code
  window.analyticsEnabled = true;
}
